<template>
  <div>
    <vue-portal to="hrsys-navbar">
      <base-header-title :title="$t('modules.configurations')"/>
    </vue-portal>
    <base-loader :loading="loadingData">
      <configs-component :configs="configs" :loading="loading" @confirm="updateConfigs"/>
    </base-loader>
  </div>
</template>

<script>
  import ConfigsComponent from "../../components/configs/ConfigsComponent"
  import Configs from "../../services/Configs";

  export default {
    name: "Configs",
    components: {
      ConfigsComponent
    },
    data: () => ({
      configs: {},
      loadingData: false,
      loading: false
    }),
    methods: {
      getConfigs () {
        this.loadingData = true;
        Configs.getConfigs().then(result => {
          this.configs = result.data
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingData = false
        })
      },
      updateConfigs () {
        this.loading = true;
        Configs.updateConfigs(this.configs).then(() => {
          this.$notificationService.success(this.$t('config.successUpdate'))
        }).catch((error) => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loading = false
        })
      },
    },
    mounted () {
      this.getConfigs()
    }
  }
</script>

<style scoped>

</style>
